import { ConnectionError, ServiceUnavailableError, UnauthorizedAccessError } from '../app/errors';
import BadPhoneNumberError, { VerificationConflictError } from './errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const constructMobileNumberStartVerificationUrl = (mobileNumber) => (
  `${api_config.bet_tracker_api}/phonenumber/${mobileNumber}/startPhoneVerification`
);

const constructMobileNumberCompleteVerificationUrl = (mobileNumber) => (
  `${api_config.bet_tracker_api}/phonenumber/${mobileNumber}/completePhoneVerification`
);

const invalidateTokenUrl = `${api_config.bet_tracker_api}/account/invalidateToken`;

export const postMobileNumber = (mobileNumber) => (
  fetch(constructMobileNumberStartVerificationUrl(mobileNumber), {
    method: 'POST',
    headers: POST_HEADERS
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;
      switch (status) {
        case 202: {
          return response;
        }
        case 400: {
          throw new BadPhoneNumberError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);

export const postVerificationCode = (mobileNumber, verificationCode) => (
  fetch(constructMobileNumberCompleteVerificationUrl(mobileNumber), {
    method: 'POST',
    headers: POST_HEADERS,
    body: JSON.stringify({ verificationCode }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;
      switch (status) {
        case 204: {
          return response;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 409: {
          throw new VerificationConflictError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);

export const postInvalidateToken = () => (
  fetch(invalidateTokenUrl, {
    method: 'POST',
    headers: POST_HEADERS,
    credentials: 'include'
  })
    .catch(err => {
      throw new ConnectionError(err.statusText, err.status);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
